import React from 'react';
import classNames from 'classnames';
import { DevicePhoneMobileIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import { NOTIFICATION_CHANNELS } from 'constants/notifications';
import { getNotificationChannelLabel } from 'utils/notifications';

export default function NotificationChannelIndicator({ channel, className = '' }) {
  const label = getNotificationChannelLabel(channel);

  if (channel === NOTIFICATION_CHANNELS.BOTH) {
    return (
      <span
        title={label}
        aria-label={label}
        className={classNames('inline-flex items-center text-gray-400', className)}
      >
        <EnvelopeIcon className="size-4" aria-hidden="true" />
        <DevicePhoneMobileIcon className="-ml-1 size-4" aria-hidden="true" />
      </span>
    );
  }

  if (channel === NOTIFICATION_CHANNELS.PHONE) {
    return (
      <span
        title={label}
        aria-label={label}
        className={classNames('inline-flex items-center text-gray-400', className)}
      >
        <DevicePhoneMobileIcon className="size-4" aria-hidden="true" />
      </span>
    );
  }

  return (
    <span
      title={label}
      aria-label={label}
      className={classNames('inline-flex items-center text-gray-400', className)}
    >
      <EnvelopeIcon className="size-4" aria-hidden="true" />
    </span>
  );
}
